function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m495.8 127.57v256.86h-479.6v-256.86z",
  fill: "#58935e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m433.71 159h-356.42c0 18-14.29 31.38-31.29 31.88v130.24c17 .5 31.29 14.88 31.29 32.88h356.42c0-18 13.29-32.38 30.29-32.88v-130.24c-17-.5-30.29-13.88-30.29-31.88z",
  fill: "#7fd695"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#61b257"
}, /*#__PURE__*/React.createElement("path", {
  d: "m413 235.58a20.42 20.42 0 1 1 -20.42 20.42 20.415 20.415 0 0 1 20.42-20.42z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 160.02a95.98 95.98 0 1 1 -95.98 95.98 95.978 95.978 0 0 1 95.98-95.98zm69.71 95.98a69.71 69.71 0 1 0 -69.71 69.71 69.71 69.71 0 0 0 69.71-69.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m99 235.58a20.42 20.42 0 1 1 -20.41 20.42 20.417 20.417 0 0 1 20.41-20.42z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m76 321.12v-130.24c17-.5 31.29-13.88 31.29-31.88h-30c0 18-14.29 31.38-31.29 31.88v130.24c17 .5 31.29 14.88 31.29 32.88h30c0-18-14.29-32.38-31.29-32.88z",
  fill: "#6db57c"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m256 249.3a11.766 11.766 0 1 1 11.766-11.766 6 6 0 0 0 12 0 23.808 23.808 0 0 0 -17.766-23v-5.46a6 6 0 0 0 -12 0v5.46a23.766 23.766 0 0 0 6 46.763 11.766 11.766 0 1 1 -11.766 11.766 6 6 0 0 0 -12 0 23.806 23.806 0 0 0 17.766 23v6.866a6 6 0 0 0 12 0v-6.869a23.766 23.766 0 0 0 -6-46.763z",
  fill: "#eadf53"
});

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.0a3d7b2e.svg";
export { ForwardRef as ReactComponent };